import { lazy } from "react";

const AgreementViewPage = lazy(() => import("./AgreementViewPage"));

export { AgreementViewPage };
